/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.QuickbooksDesktop {
    angular.module("meevo.plugins.quickbooksDesktop", []);
}